export const locale = {
    lang: 'ds',
    data: {
        'Header': {
            "Title": "Kopier materialeoplysninger"
        },
        "FIELDS": {
            "MaterialNumber": "Materiale nummer",
            "Barcode":"Stregkode"
        },
        "BUTTONS": {
            "Add": "Tilføj"
        },
        'MESSAGES': {
            'Updated': 'Opdateret succesfuldt.',
            'Failed': 'Mislykkedes',
            'Deleted': 'Slettet med succes',
            'NORECORD': 'Intet optage fundet'
        },
    }
}